import { mapActions } from 'vuex'
import { decode } from 'html-entities'

export default {
  methods: {
    ...mapActions([
      'setUnsavedChanges'
    ])
  },
  watch: {
    currState (newValue) {
      if (!this.origState || this.loading) {
        return
      }
      let newFlattened = newValue.replace(/(\\n|\\r)/g, '')
      let origFlattened = this.origState.replace(/(\\n|\\r)/g, '')
      let newStripped = decode(newFlattened)
      let origStripped = decode(origFlattened)
      let found = false
      if (newStripped !== origStripped) {
        const curr = JSON.parse(newFlattened)
        const orig = JSON.parse(origFlattened)
        for (let key in orig) {
          const currData = curr[key] === 0 ? 0 : 
            (typeof curr[key] === 'string' ? decode(curr[key]) : curr[key])
          const origData = orig[key] === 0 ? 0 : 
            (typeof orig[key] === 'string' ? decode(orig[key]) : orig[key])
          // Note the "!=" with !! here, this should take care of "null" vs ""
          if (orig.hasOwnProperty(key) && origData != currData && JSON.stringify(origData) != JSON.stringify(currData)) {
            // We needed to separate this to only affect cases where we're comparing with null, otherwise pretty much anything would get caught in this
            if ((origData === null || currData === null) && !!origData == !!currData) {
              found = false
            } else if ((origData === 0 || currData === 0) && !!origData == !!currData) {
              found = false
            } else {
              found = true
            }
            /*
            if (found) {
              console.log('Differences in', key)
              console.log(orig[key])
              console.log(curr[key])
            }
            */
          }
        }
        this.setUnsavedChanges(found)
      } else {
        this.setUnsavedChanges(false)
      }
    }
  }
}